// extracted by mini-css-extract-plugin
export var animationContainer = "_nv-0";
export var footer = "_nv-1";
export var gray = "_nv-2";
export var lineItem = "_nv-3";
export var lineItemImage = "_nv-4";
export var lineItemInfo = "_nv-5";
export var lineItemText = "_nv-6";
export var lineItems = "_nv-7";
export var modalContent = "_nv-8";
export var options = "_nv-9";
export var orderName = "_nv-a";
export var refundAmount = "_nv-b";